
import { ZollerFocus } from './zoller-focus';
import { ZollerMode } from './zoller-mode';

export class ToolStep {
  constructor(
    public hash?: string,
    public step?: string,
    public ces?: number,
    public longitude?: number,
    public zollerFocus?: ZollerFocus,
    public zollerMode?: ZollerMode,
    public rangeWidth?: number,
    public rangeHeight?: number,
    public zRefMode?: number,
    public zUpperTol?: number,
    public zLowerTol?: number,
    public x?: number,
    public xRefMode?: number,
    public xUpperTol?: number,
    public xLowerTol?: number,
    public radius?: number,
    public radiusUpperTol?: number,
    public radiusLowerTol?: number,
    public angle?: number,
    public angleUpperTol?: number,
    public angleLowerTol?: number,
    public searchRunZ?: boolean,
    public searchRunX?: boolean,
    public zollerFocusName?: string,
    public zollerModeName?: string
  ) { }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/tool-step.ts